export default "__VITE_ASSET__BJLmgnp3__"